import React, { useState, useEffect } from 'react';

const rotatingTexts = [
  "dAIsy is thinking...",
  "dAIsy is processing...",
  "dAIsy is considering...",
  "dAIsy is analyzing...",
  "dAIsy is reflecting..."
];

const RotatingText = () => {
  const [currentText, setCurrentText] = useState(rotatingTexts[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText(prev => {
        const currentIndex = rotatingTexts.indexOf(prev);
        const nextIndex = (currentIndex + 1) % rotatingTexts.length;
        return rotatingTexts[nextIndex];
      });
    }, 2000); // Change text every 2 seconds

    return () => clearInterval(interval); // Clean up on unmount
  }, []);

  return (
    <div className="rotating-text">
      <p>{currentText}</p>
    </div>
  );
};

export default RotatingText;
